module.exports = __webpack_public_path__ + "static/media/download (2).c942a86e.svg";